import { render, staticRenderFns } from "./TablaServiciosOferta.vue?vue&type=template&id=619846c1"
import script from "./TablaServiciosOferta.vue?vue&type=script&lang=js"
export * from "./TablaServiciosOferta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports